{	"main": {
		"title": "Dnevnik pilota",
		"nazaj": "Nazaj"
	},
	"navs": {
		"vnos": "Vnos",
		"dnevnik": "Dnevnik"
	},
	"labels": {
		"datum": "Datum :",
		"casO":"Čas odhoda :",
		"krajV":"Kraj vzleta : LJAJ",
		"casP":"Čas prihoda :",
		"krajP":"Kraj pristanka : LJAJ",
		"model":"Model, varianta",
		"reg":"Registracija letala: S5-XYZ",
		"ime":"Ime vodje zrakoplova",
		"posadka":"Enočlanska / Veččlanska posadka :",
		"posadkaVec":"VEČ",
		"skupniCas":"Skupni čas letenja Total time of flight:",
		"stPristankovDN":"Št. pristankov (Dan / Noč) :",
		"dan":"Dan",
		"noc":"Noč",
		"stPristankov":"Št. pristankov :",
		"op":"Operativni pogoji :",
		"opD":"Dnevno",
		"opN":"Nočno",
		"vlogaP":"Vloga pilota :",
		"fstd":"Skupni čas na FSTD:",
		"opomba":"Opomba"
	},
	"buttons": {
		"vnesiZapis": "Vnesi zapis"
	},
	"obvestila": {
		"zapisDodan": "Zapis uspešno dodan.",
		"napakaVnosa": "Napaka pri vnosu podatkov.",
		"napakaInputa": "Za dodajanje zapisa morajo biti izpolnjeni vsi podatki. Preverite, da ste izpolnili vse podatke!",
		"napakaBranja": "Napaka pri branju podatkov."
	}
}